import { useEffect, useRef } from 'react';

export default function usePrevious(value, shouldSetInitValue) {
  const ref = useRef(shouldSetInitValue ? value : undefined);
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}
